import React from "react";
import Payments from "./Payments";


const PaymentsVente = () => {
    return <Payments tierLabel="Client" tiersApi="Clients" />;
};

export default PaymentsVente;
